export class TenantSensor {
    id: string;
    name: string;
    imeI_No: string;
    latitude: number;
    longitude: number;
    status: boolean;
    installationDate: Date;
    installDate: string;
    tenantId: string;
    organizationLevelId?: string;
    tenantName: string;
    deviceVersionId?: string;
    deviceVersion: string;
    gpsCapability: boolean;
    tableNames: string[];
    videoCapability: boolean;
    density: number;
    airNowIntlAQSCode: string;
    configurationCapability: boolean;
}
